export function validateAppointmentNotes(notes: string, maxLength = 500): string | null {
  if (notes.length > maxLength) {
    return `Appointment notes cannot exceed ${maxLength} characters (currently ${notes.length}).`;
  }
  // Control chars 0x00–0x08, 0x0B (VT), 0x0C (FF), 0x0E–0x1F, 0x7F — excluding \t (0x09), \n (0x0A), \r (0x0D)
  // eslint-disable-next-line no-control-regex
  if (/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/.test(notes)) {
    return 'Appointment notes contain invalid control characters.';
  }
  if (/[<>]/.test(notes)) {
    return 'Appointment notes cannot contain angle brackets (< or >).';
  }
  return null;
}

export function isHmoInsurance(name: string | null | undefined): boolean {
  if (!name) return false;
  return name
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .split(/\s+/)
    .some((token) => token.toLowerCase() === 'hmo');
}

export function buildAppointmentNotes({
  isNewPatient,
  hospitalName,
  estimatedDischargeDate,
  insuranceName,
  isFirstTimePcp,
  pcpName,
}: {
  isNewPatient: boolean;
  hospitalName: string | undefined;
  estimatedDischargeDate: string | undefined;
  insuranceName?: string | null;
  isFirstTimePcp?: boolean;
  pcpName?: string;
}): string {
  const parts: string[] = [];
  if (isNewPatient) {
    parts.push(
      isHmoInsurance(insuranceName)
        ? 'Patient is a new patient with HMO insurance and no established PCP relationship.'
        : 'Patient is a new patient with no established PCP relationship.',
    );
  } else if (isFirstTimePcp && pcpName) {
    parts.push(`This patient has not been seen by ${pcpName} before.`);
  }
  if (hospitalName && estimatedDischargeDate) {
    parts.push(
      `Patient was discharged from ${hospitalName} on ${estimatedDischargeDate}.`,
    );
  }
  parts.push('Reason for admittance: ');
  parts.push('Diagnosis: ');
  return parts.join('\n');
}
